export default [
    {
        name: 'auditCreate',
        path: '/audit/create/:projectId',
        component: require('@/pages/AuditCreate').default,
        props: (route) => ({
            projectId: +route.params.projectId,
        }),
        meta: {
            back: { label: ':projectName', to: '/project/view/:projectId' },
            security: (auth) => auth.can({ action: 'create', model: 'audit' })
        }
    },
    {
        name: 'auditEdit',
        path: '/audit/edit/:auditId',
        component: require('@/pages/AuditEdit').default,
        props: (route) => ({
            auditId: +route.params.auditId,
        }),
        meta: {
            back: { label: 'Dashboard', to: '/' },
            //NB: auditEdit is also used for viewing by EOs. Edit security handled on page.
            security: (auth) => auth.can({ action: 'view', model: 'audit', arg: +auth.to.params.auditId })
        }
    },
    {
        name: 'auditEquipmentCreate',
        path: '/auditEquipment/create/:auditId',
        component: require('@/pages/AuditEquipmentCreate').default,
        props: (route) => ({
            auditId: +route.params.auditId,
        }),
        meta: {
            back: { label: 'Audit', to: '/audit/edit/:auditId' },
            security: (auth) => auth.can({ action: 'edit', model: 'audit', arg: +auth.to.params.auditId })
        }
    },
    {
        name: 'auditEquipmentEdit',
        path: '/auditEquipment/edit/:auditId/:auditEquipmentId',
        component: require('@/pages/AuditEquipmentEdit').default,
        props: (route) => ({
            auditEquipmentId: +route.params.auditEquipmentId,
            auditId: +route.params.auditId,
            viewOnly: false,
        }),
        meta: {
            back: { label: 'Audit', to: '/audit/edit/:auditId' },
            //NB: auditEquipmentEdit is also used for viewing by EOs. Edit security handled on page.
            security: (auth) => auth.can({
                action: 'view',
                model: 'audit-equipment',
                arg: +auth.to.params.auditEquipmentId
            })
        }
    },
    {
        name: 'auditEquipmentView',
        path: '/auditEquipment/view/:auditId/:auditEquipmentId',
        component: require('@/pages/AuditEquipmentEdit').default,
        props: (route) => ({
            auditEquipmentId: +route.params.auditEquipmentId,
            auditId: +route.params.auditId,
            viewOnly: true,
        }),
        meta: {
            back: { label: 'Audit', to: '/audit/edit/:auditId' },
            //NB: auditEquipmentEdit is also used for viewing by EOs. Edit security handled on page.
            security: (auth) => auth.can({
                action: 'view',
                model: 'audit-equipment',
                arg: +auth.to.params.auditEquipmentId
            })
        }
    }
]